import React, { createContext, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { createToastStackLimiter, type GlobalToastHandle } from './utils/toastStackLimiter';

type GlobalToastContextType = {
  toastRef: React.RefObject<GlobalToastHandle | null>;
};

type GlobalToastProviderProps = React.PropsWithChildren<{
  /** The most toasts on screen at once; another closes the oldest. Unlimited when unset. Read on mount. */
  maxToasts?: number;
}>;

// eslint-disable-next-line react-refresh/only-export-components
export const GlobalToastContext = createContext<GlobalToastContextType | undefined>(undefined);

export const GlobalToastProvider: React.FC<GlobalToastProviderProps> = ({ children, maxToasts }) => {
  const primeToastRef = useRef<Toast | null>(null);
  const [limiter] = useState(() => createToastStackLimiter(() => primeToastRef.current, maxToasts));
  const toastRef = useRef<GlobalToastHandle | null>(limiter.handle);

  return (
    <GlobalToastContext.Provider value={{ toastRef }}>
      {/* PrimeReact Toast component */}
      <Toast ref={primeToastRef} position="top-right" onRemove={limiter.handleRemove} />
      {children}
    </GlobalToastContext.Provider>
  );
};
